module.exports = __webpack_public_path__ + "img/wired-28072019.ff836c9e.webp";